import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LocationService } from 'mds-ui/app/modules/fingerprint/fingerprint-summary/service/location.service';
import { Comon } from 'mds-ui/app/shared/model/common';
import { LoggedInInfo } from 'mds-ui/app/shared/model/login.model';
import { Constants } from 'mds-ui/app/shared/pipes/constants';
import { CommonService } from 'mds-ui/app/shared/service/common.service';
import { LoginService } from 'mds-ui/app/shared/service/login.service';
import { PersonInfoService } from '../../modules/common/associates/service/personinfo.service';
import { ApplicationService } from '../../modules/users/admin-users/service/application.service';
import { UserRoleProfileService } from '../../modules/users/admin-users/service/userrole-profile.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',

})
export class HeaderComponent implements OnInit {
  authorityCode: string;
  @Input() userName: string = "";
  @Input() appName: string = "";
  @Input() profileName: string = "";
  @Input() displayableId: string = "";
  @Input() accessToken: string = "";
  public loggedInInfo: LoggedInInfo;
  @Input() showFlag: boolean = null;
  list: Comon[];
  locationName: string;
  constructor(private router: Router, private loginService: LoginService,
    private applicationService: ApplicationService, private locationService: LocationService,
    private userRoleProfileService: UserRoleProfileService, private personInfoService: PersonInfoService,
    private activatedRoute: ActivatedRoute, private commonService: CommonService) { }

  ngOnInit() {
    this.locationName = 'All Locations';
    this.list = this.commonService.Reports;
  }
  ngDoCheck() {
    if (this.locationName != this.userRoleProfileService.locationName) {
      this.locationName = this.userRoleProfileService.locationName;
    }
  }
  toSwitchLocationModal(e: Event) {
    e.preventDefault();
    if (this.router.url != "/app-humanresource/app-switch-location-modal") {
      this.router.navigate(["/app-humanresource/app-switch-location-modal"], { queryParams: { id: new Date().getTime() }, relativeTo: this.activatedRoute });
    }
  }

  toEmployee($event: Event, type: string): void {
    $event.preventDefault();
    if (this.applicationService.application.name == "fingerprint") {
      this.locationService.applicantSearchVO = undefined;
      this.router.navigate(["/app-fingerprint-type/app-summary-fingerprint"], { queryParams: { id: new Date().getTime() } });
    }
    else if (this.applicationService.application.name == "seminarian") {
      this.router.navigate(["/app-seminarian/app-seminarian-summary"], { queryParams: { type: type, id: new Date().getTime() } });
    }
    else if (this.applicationService.application.name == "priest") {
      this.router.navigate(["/app-priest/app-priest-summary"], { queryParams: { id: new Date().getTime() } });
    }
    else if (this.applicationService.application.name == "studentipm") {
      this.router.navigate(["/app-studentipm/app-student-summary"], { queryParams: { id: new Date().getTime() } });
    }
    else if (this.applicationService.application.name == "humanresources") {
      this.router.navigate(["/app-humanresource/app-humanresource-summary"], { queryParams: { id: new Date().getTime() } });
    }
    else if (this.applicationService.application.name == "deacon") {
      this.router.navigate(["/app-deacon/app-deacon-summary"], { queryParams: { id: new Date().getTime() } });
    }
    else {
      this.router.navigate(["/app-associate-type/app-summary"], { queryParams: { id: new Date().getTime() } });
    }
  }
  toPayroll($event: Event, type: string): void {
    $event.preventDefault();
    this.router.navigate(["/app-humanresource/app-payrollmanagers"], { queryParams: { type: type, id: new Date().getTime() } });
  }
  toCCC($event: Event): void {
    $event.preventDefault();
    this.router.navigate(["/app-humanresource/app-christ-cathedral-campus"], { queryParams: { id: new Date().getTime() } });
  }
  toApplication($event: Event): void {
    $event.preventDefault();
    this.router.navigate(["/app-fingerprint-type/app-livescanblank"], { queryParams: { id: new Date().getTime() } });
  }
  myInfo($event: Event): void {
    $event.preventDefault();
    this.personInfoService.getPersonInfoByMail(this.userRoleProfileService.getUserEmailID()).subscribe(data => {
      let response = data as any;
      this.personInfoService.personInfo = response.personInfoVOList[0];
      this.router.navigate(["/app-associate-type/app-my-info"], { queryParams: { id: new Date().getTime(), } });
    })
  }
  toFormation($event: Event): void {
    $event.preventDefault();
    this.router.navigate(["/app-priest/app-formation"], { queryParams: { id: new Date().getTime(), } });

  }
  toOrganization($event: Event): void {
    $event.preventDefault();
    this.router.navigate(["/app-priest/app-organization-summary"], { queryParams: { id: new Date().getTime(), } });

  }
  tohome($event: Event): void {
    $event.preventDefault();
    if (this.applicationService.application.name == "fingerprint") {
      this.router.navigate(["/app-fingerprint-type/app-reports-fingerprint"], { queryParams: { id: new Date().getTime() } });
    } else if (this.applicationService.application.name == "priest") {
      this.router.navigate(["/app-priest/app-priest-reports"], { queryParams: { id: new Date().getTime() } });
    } else {
      this.router.navigate(["../app-reports"], { queryParams: { id: new Date().getTime() } });
    }
  }
  toDashboard($event: Event): void {
    $event.preventDefault();
    if (this.applicationService.application.name == "fingerprint") {
      this.router.navigate(["/app-fingerprint-type/app-fingerprint-dashboard"], { queryParams: { id: new Date().getTime() } });
    }
  }
  toIndividualReports($event: Event, id: string): void {
    $event.preventDefault();
    let reportId: string;
    reportId = id;
    this.locationService.locationInfoInit();
    if (this.applicationService.application.name == "fingerprint") {
      this.locationService.reports.reportsId = id;
      this.router.navigate(["/app-fingerprint-type/app-fingerprint-individual-reports"], { queryParams: { id: new Date().getTime() } });
    } else if (this.applicationService.application.name == "priest") {
      this.locationService.reports.reportsId = id;
      this.locationService.reports.isProcess = true;
      this.router.navigate(["/app-priest/app-priest-individual-reports"], { queryParams: { report: id, id: new Date().getTime() } });
    } else if (this.applicationService.application.name == "deacon") {
      this.locationService.reports.reportsId = id;
      this.locationService.reports.isProcess = true;
      this.router.navigate(["/app-deacon/app-deacon-individual-reports"], { queryParams: { report: id, id: new Date().getTime() } });
    } else if (this.applicationService.application.name == "seminarian") {
      this.locationService.reports.reportsId = id;
      this.locationService.reports.isProcess = true;
      this.router.navigate(["/app-seminarian/app-seminarian-individual-reports"], { queryParams: { report: id, id: new Date().getTime() } });
    }
  }
  toMain($event) {
    $event.preventDefault();
    if (this.applicationService.application.name == "fingerprint") {
      this.router.navigate(["/app-fingerprint-type/app-summary-fingerprint"], { queryParams: { id: new Date().getTime() } });
    } else if (this.applicationService.application.name == "seminarian") {
      this.router.navigate(["/app-seminarian/app-seminarian-summary"], { queryParams: { type: 'S', id: new Date().getTime() } });
    } else if (this.applicationService.application.name == "priest") {
      this.router.navigate(["/app-priest/app-priest-summary"], { queryParams: { id: new Date().getTime() } });
    } else if (this.applicationService.application.name == "studentipm") {
      this.router.navigate(["/app-studentipm/app-student-summary"], { queryParams: { id: new Date().getTime() } });
    } else if (this.applicationService.application.name == "deacon") {
      this.router.navigate(["/app-deacon/app-deacon-summary"], { queryParams: { id: new Date().getTime() } });
    }
   else if (this.applicationService.application.name == "directory") {
    this.router.navigate(["/app-psms/app-parishschools"], { queryParams: { id: new Date().getTime() } });
  }
    else {
      this.router.navigate(["/app-associate-type/app-summary"], { queryParams: { id: new Date().getTime() } });
    }
  }
  onCommunity($event: Event) {
    $event.preventDefault();
    this.router.navigate(["/app-master-data-setup/app-community"], { queryParams: { id: new Date().getTime() } });
  }
  onBulkUpdates($event: Event) {
    $event.preventDefault();
    this.router.navigate(["/app-master-data-setup/app-bulk-updates"], { queryParams: { id: new Date().getTime() } });
  }
  onOrganization($event: Event) {
    $event.preventDefault();
    this.router.navigate(["/app-master-data-setup/app-organization"], { queryParams: { id: new Date().getTime() } });
  }
  onParishschools($event: Event) {
    $event.preventDefault();
    this.router.navigate(["/app-psms/app-parishschools"], { queryParams: { id: new Date().getTime() } });
  }
  onSettings($event: Event) {
    $event.preventDefault();
    this.router.navigate(["../app-setting"], { queryParams: { id: new Date().getTime() } });
  }
  onProfileManagement($event: Event) {
    $event.preventDefault();
    this.router.navigate(["/app-admin-profile/app-profile-management"], { queryParams: { id: new Date().getTime() } });
  }
  onRoleManagement($event: Event) {
    $event.preventDefault();
    this.router.navigate(["/app-admin-roles/app-role-management"], { queryParams: { id: new Date().getTime() } });
  }
  onUserManagement($event: Event) {
    $event.preventDefault();
    this.router.navigate(["../app-admin-users"], { queryParams: { id: new Date().getTime() } });
  }

  toPsmsUsers($event: Event) {
 $event.preventDefault();
 
    this.router.navigate(["/app-psms-users/app-displaypsms-users"], { queryParams: { id: new Date().getTime() } });
  }

  onHouseName($event: Event) {
    $event.preventDefault();
    this.router.navigate(["/app-master-data-setup/app-house-name"], { queryParams: { id: new Date().getTime() } });
  }
  onSuperior($event: Event) {
    $event.preventDefault();
    this.router.navigate(["/app-master-data-setup/app-local-superior"], { queryParams: { id: new Date().getTime() } });
  }
  onMajorSuperior($event: Event) {
    $event.preventDefault();
    this.router.navigate(["/app-master-data-setup/app-major-superior"], { queryParams: { id: new Date().getTime() } });
  }
  onCPAS($event: Event) {
    $event.preventDefault();
    this.router.navigate(["app-cpas"], { queryParams: { id: new Date().getTime() } });
  }

  onPAD($event: Event) {
    $event.preventDefault();
    this.router.navigate(["app-reports"], { queryParams: { id: new Date().getTime() } });
  }

  onHR($event: Event) {
    $event.preventDefault();
    this.router.navigate(["app-reports"], { queryParams: { id: new Date().getTime() } });
  }
  toSignOut(e: Event) {
    e.preventDefault();
    window.location.href = this.loginService.getLogOutEndpoint();
  }

  onClasses($event: Event) {
    $event.preventDefault();
    this.router.navigate(["/app-studentipm/app-classes-summary"], { queryParams: { id: new Date().getTime() } });
  }
  onCertificates($event: Event) {
    $event.preventDefault();
    this.router.navigate(["/app-studentipm/app-certificates-summary"], { queryParams: { id: new Date().getTime() } });
  }
  onCourse($event: Event) {
    $event.preventDefault();
    this.router.navigate(["/app-studentipm/app-course-summary"], { queryParams: { id: new Date().getTime() } });
  }
  onLocations($event: Event) {
    $event.preventDefault();
    this.router.navigate(["/app-studentipm/app-location-summary"], { queryParams: { id: new Date().getTime() } });
  }
  onReports($event: Event) {
    $event.preventDefault();
    this.router.navigate(["/app-studentipm/app-basicreports"], { queryParams: { id: new Date().getTime() } });
  }
  onRegistration($event: Event) {
    $event.preventDefault();
    this.router.navigate(["/app-studentipm/app-registration-summary"], { queryParams: { id: new Date().getTime() } });
  }
  isEnable(menuName: string) {
    return this.userRoleProfileService.isAccessible(menuName, Constants.PERMISSIONS_ENABLED);
  }
  isEnabled(fieldName: string) {
    return this.userRoleProfileService.isAccessible(fieldName, Constants.PERMISSIONS_ENABLED);
  }
  toPayrollAdjustments($event: Event): void {
    $event.preventDefault();
    this.router.navigate(["/app-humanresource/app-payroll-adjustments-history"], { queryParams: { id: new Date().getTime() } });
  }
}
